<mat-card-content
  class="d-flex flex-column justify-content-center align-items-center"
>
  <p *ngIf="data.message" class="title-forms text-center" [innerHtml]="data?.message"></p>
  <div
    *ngIf="data.yes || data.no"
    class="d-flex justify-content-center flex-column align-items-center section-button c-b"
  >
    <button
      *ngIf="data.yes"
      id="confirmComponentYes"
      mat-flat-button
      class="button-primary-event button-success"
      [mat-dialog-close]="'true'"
    >
      {{ data?.yes }}
    </button>
    <button
      *ngIf="data.no"
      id="confirmComponentNo"
      mat-stroked-button
      mat-dialog-close
      class="border-box b-s"
    >
      {{ data?.no }}
    </button>
  </div>
</mat-card-content>
